import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import type React from "react";
import { useMemo } from "react";
import { useField } from "@tanstack/react-form";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";

import type { AttributeInputProps } from "./types.ts";
import "./attribute-filter.css"

export const Znacka: React.FC<AttributeInputProps> = ({
  overviewForm,
  attributesList,
  allAds
}) => {
  const field = useField({
    form: overviewForm,
    // biome-ignore lint/nursery/noSecrets: ...
    name: "DetailCategoryFilter.Znacka",
  });
  const value = useMemo(() => field.state.value, [field.state.value])

  const attribute = useMemo(() => attributesList.find((attr) => attr.name === "Znacka"), [attributes]);

  const znackaNames: string[] = useMemo(() => {
    const unique: Record<string,string> = {};
    for (const item of allAds) {
      if(item.attributes.model) {
        const znacka = item.attributes.znacka;
        if(znacka) {
          unique[znacka] = znacka;
        }
      }
    }
    const result = Object.keys(unique).toSorted((a: string, b: string) => a.localeCompare(b));
    return result;
  }, [allAds]);

  if (!attribute) {
    return null;
  }

  return (
    <div
      className={"SZAutoComplete"} // items are inserted after Autocomplete
    >
      <Autocomplete
        value={value ?? null}
        size="small"
        disablePortal={true}
        fullWidth={true}
        options={znackaNames}
        onChange={(_e, value) => {
          // setFilterAtom(value ?? ""); // do not reload page
          field.setValue(value ?? "");
        }}
        renderInput={(params) => (
          <TextField {...params} color="secondary" variant="filled"  label={"Značka"} />
        )}
        clearIcon={
          <IconButton
            size="small"
            color="error"
            onClick={() => {
              field.setValue("");
            }}
          >
            <Close/>
          </IconButton>
          }
      />
    </div>
  )

  // return (
  //   <overviewForm.Field name="DetailCategoryFilter.Znacka">
  //     {(fieldApi) => {
  //       const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //         if (e.key === "Enter") {
  //           // fieldApi.setValue(filterAtom);
  //           e.preventDefault();
  //         }
  //       };
  //       return (
  //         <TextField
  //           label="Značka"
  //           fullWidth={true}
  //           color="secondary"
  //           size="small"
  //           variant="filled"
  //           value={fieldApi.state.value}
  //           onChange={(e) => fieldApi.setValue(e.target.value)}
  //           onKeyDown={handleKeyDown}
  //           inputMode="numeric"
  //           slotProps={{
  //             input: {
  //               endAdornment: fieldApi.state.value ? (
  //                 <IconButton
  //                   size="small"
  //                   color="error"
  //                   onClick={() => {
  //                     fieldApi.setValue("");
  //                   }}
  //                 >
  //                   <Close />
  //                 </IconButton>
  //               ) : null,
  //             },
  //           }}
  //         />
  //       );
  //     }}
  //   </overviewForm.Field>
  // );
};
